import React from 'react';

import type { Props } from '@swf/components/StarsButton/StarsButton';
import StarsButton from '@swf/components/StarsButton/StarsButton';

import { playAnimations } from '../../utils/animation';

export interface AnimatedButtonProps {
  animation: React.FC;
}

const AnimatedButton: React.FC<Props & AnimatedButtonProps> = ({
  animation: Animation,
  onClick,
  ...rest
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);

    playAnimations(event);
  };

  return (
    <>
      <Animation />
      <StarsButton {...rest} onClick={handleClick} variant="text" />
    </>
  );
};

export default AnimatedButton;
